import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useI18n } from '../i18n';
import { controllerDetailPath, controllerFilesPath, controllerHardwarePath } from '../nav/paths';

type ControllerTab = 'overview' | 'hardware' | 'files';

function tabFromPath(pathname: string): ControllerTab {
  if (pathname.endsWith('/files')) {
    return 'files';
  }
  if (pathname.endsWith('/hardware')) {
    return 'hardware';
  }
  return 'overview';
}

const ControllerWorkspace: React.FC = () => {
  const { t } = useI18n();
  const { deviceId = '' } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const tab = tabFromPath(location.pathname);

  const go = (next: ControllerTab) => {
    if (next === 'hardware') {
      navigate(controllerHardwarePath(deviceId));
      return;
    }
    if (next === 'files') {
      navigate(controllerFilesPath(deviceId));
      return;
    }
    navigate(controllerDetailPath(deviceId));
  };

  return (
    <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
      <Tabs
        value={tab}
        onChange={(_, next: ControllerTab) => go(next)}
        sx={{ px: { xs: 1, md: 2 }, borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper', minHeight: 44 }}
      >
        <Tab value="overview" label={t('detail.tabOverview')} sx={{ minHeight: 44 }} />
        <Tab value="hardware" label={t('deviceConfig.title')} sx={{ minHeight: 44 }} />
        <Tab value="files" label={t('nav.setupFiles')} sx={{ minHeight: 44 }} />
      </Tabs>
      <Box sx={{ flex: 1, minHeight: 0, overflow: 'auto', display: 'flex', flexDirection: 'column' }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default ControllerWorkspace;
